import React from "react";

const NewsItem = ({ item, onClick }) => {
  return (
    <div className="home-news-wrapper cursor-pointer" onClick={onClick}>
      <article className="home-news bg-white shadow-md rounded-2xl overflow-hidden hover:shadow-lg transition">
        <div className="relative">
          <span className="home-news__date absolute bottom-2 left-2 bg-black/70 text-white text-sm px-2 py-1 rounded">
            {new Date(item.date).toLocaleDateString("ru-RU")}
          </span>
        </div>

        <div className="home-news__body p-4">
          <h2 className="home-news__title text-lg font-semibold mb-2 line-clamp-2">
            {item.title}
          </h2>
          <p className="home-news__desc text-gray-600 text-sm line-clamp-3">
            {item.shortText}
          </p>
        </div>
      </article>
    </div>
  );
};

export default NewsItem;
